module.exports = __webpack_public_path__ + "4996f5ee5b0816cd3b4792c5ce8abce5.png";